// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

// "require" forces the load of code in the order in which is written
// "import" lines can be reorder by the intrerpreter/cpu/whatever.

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

// Support component names relative to this directory:
var componentRequireContext = require.context("components", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);

// Wrap every react-rails mount in the shared MUI ThemeProvider (brand palette).
require("../theme/setupReactRails").default(ReactRailsUJS);

// Initialize dayjs configuration (Spanish locale with capitalized months)
require("../utils/dayjs-config");
